import React from "react";
import { NAV_LINKS, BRAND } from "../mock";

const Footer = () => {
  return (
    <footer className="bg-[#140f0a] text-stone-300 pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="grid md:grid-cols-3 gap-10 pb-10 border-b border-white/10">
          <div>
            <div className="mb-4">
              <img src="/alramz-logo.png" alt="الرمز Alramz" className="h-12 w-auto object-contain" />
            </div>
            <p className="text-sm leading-relaxed text-stone-400 max-w-xs">
              مشروع {BRAND.name} ضمن وجهة مسار، برجان سكنيان قرب الحرم المكي.
            </p>
            <p className="text-xs text-[#BF9A5A] mt-4">{BRAND.license}</p>
          </div>

          <div>
            <h4 className="text-white font-700 mb-4">روابط سريعة</h4>
            <ul className="space-y-2 text-sm">
              {NAV_LINKS.map((l) => (
                <li key={l.href}>
                  <a href={l.href} className="hover:text-[#D9C08A] transition-colors">{l.label}</a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-white font-700 mb-4">المسوق الحصري</h4>
            <p className="text-sm text-stone-400 leading-relaxed">
              عقارماب — للحصول على تفاصيل المشروع والتواصل المباشر مع فريق المبيعات.
            </p>
          </div>
        </div>

        <div className="pt-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-stone-500">
          <span>© {new Date().getFullYear()} {BRAND.name} — جميع الحقوق محفوظة.</span>
          <a href="/dashboard" className="hover:text-stone-300 transition-colors">لوحة التحكم</a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
